import get from 'lodash.get';

import httpClient from '@api/client';
import { lookup, mapKeys, transform } from '@utils/transform';

import itemMap from './transform/item-map';

// const sleep = (ms) => {
//     return new Promise((resolve) => setTimeout(resolve, ms));
// };
// Client Side Filtering only during prototyping
if (process.env.VUE_APP_PROTOTYPING) {
    httpClient.interceptors.response.use(async (res) => {
        // Add  delay to the response for UI loaders

        // Only filter on API calls to the orders path in this interceptor
        if (res.config.url.includes('/orders/')) {
            //       await sleep(150); //
            // filter the results if we have a parameter set
            res.data = applyFilter(res.data, res.config);
        }
        return res;
    });
}
/**
 * applyFilter - filter response data from input parameters
 * @param {*} data
 * @param {*} config
 */
const applyFilter = (data, config) => {
    const params = get(config, 'params', {});
    if (Object.keys(params).length) {
        let items = get(data, 'data.page.data', []);
        items = items.filter((item) => {
            let includeItems = [];

            for (const key in params) {
                switch (key) {
                    case 'assigned_to':
                        includeItems.push(
                            item[key].id.toString() === params[key]
                        );
                        break;
                    case 'date_range':
                        includeItems.push(true); // TODO: add date range filter
                        break;
                    case 'property':
                        includeItems.push(
                            item[key].id.toString() === params[key]
                        );
                        break;
                    case 'company':
                        includeItems.push(
                            item.property[key].id.toString() === params[key]
                        );
                        break;
                    case 'status':
                        includeItems.push(
                            item[key].toLowerCase() ===
                                params[key].toLowerCase()
                        );
                        break;
                    case 'time_pending':
                        includeItems.push(true); // TODO: add time pending filter
                        break;
                }
            }
            return includeItems.every((val) => val);
        });
        // Reset items to the filtered set
        data.data.page.data = items;
    }
    return data;
};

const postProcessScreen = (data) => {
    let { screen, application } = data;
    screen['status'] = lookup(screen.status, 'status', itemMap);
    screen = transform(screen, ['details'], itemMap);

    return { screen, application };
};

const getParams = (params) => {
    let filterParams = {};
    for (const key in params) {
        if (get(params, `${key}.value`, '').toString().length > 0) {
            filterParams[key] = get(params, `${key}.value`, '').toString();
        }
    }
    return filterParams;
};

export default {
    async getSearchResults(term) {
        const params = { term };
        let { data } = await httpClient.get('/orders/search', {
            params,
        });
        let items = get(data.data, 'page.data', []);
        items.forEach((screen) => {
            try {
                screen.status = lookup(screen.status, 'status', itemMap);
            } catch (error) {
                console.log(error);
                screen.status = 'APPLICANT_COMPLETED';
            }
        });
        return data.data;
    },

    async getScreens(filterParams, pagination) {
        const params = Object.assign({}, getParams(filterParams), pagination);
        let { data } = await httpClient.get('/orders', {
            params,
        });
        let items = get(data.data, 'page.data', []);
        items.forEach((screen) => {
            try {
                screen.status = lookup(screen.status, 'status', itemMap);
            } catch (error) {
                console.log(error);
                screen.status = 'APPLICANT_COMPLETED';
            }
        });
        return data.data;
    },
    async getScreen(id, params) {
        let res = await httpClient.get(`/orders/${id}`, {
            params,
        });

        return postProcessScreen(res.data.data);
    },
    async getPrintableScreen(params) {
        const urlPrefix = process.env.VUE_APP_PRINTABLE_URL_PREFIX ?? '';

        console.log('URL Prefix = %s', urlPrefix);
        // We have to use the printable URL here as we are verifying signature
        let res = await httpClient.get(
            `${urlPrefix}/printable/orders/${params.id}?expires=${params.expires}&signature=${params.signature}`
        );
        return postProcessScreen(res.data.data);
    },
    async printScreen(id, uuid) {
        // NOTE: Order is a type here so it's singular
        let res = await httpClient.get(`/print/order/${id}?uuid=${uuid}`);
        return res.data;
    },
    async resubmitScreen(applicant_id) {
        let res = await httpClient.get(`/applicants/resubmit/${applicant_id}`);
        return res.data;
    },

    async getStates() {
        let res = await httpClient.get('/states');
        return res.data;
    },
    async getScreeners() {
        let res = await httpClient.get('/screeners');
        return res.data.data;
    },
    async getApplications() {
        let res = await httpClient.get('/applications');
        return res.data.data;
    },
    async getApplication(id) {
        let res = await httpClient.get(`/applications/${id}`);
        return res.data.data;
    },

    async getApplicants() {
        let res = await httpClient.get('/applicants');
        return res.data.data;
    },
    async getApplicant(id) {
        let res = await httpClient.get(`/applicants/${id}`);
        let applicant = res.data.data;
        return {
            ...applicant,
            ...mapKeys(
                applicant,
                ['application_details', 'applicant_profile'],
                itemMap
            ),
        };
    },

    async getLandlords() {
        let res = await httpClient.get('/landlords');
        return res.data;
    },
    async getEmployers() {
        let res = await httpClient.get('/employers');
        return res.data;
    },
    async getApplicantImports() {
        let res = await httpClient.get('/imports');
        return res.data;
    },
    async importApplicant(importData) {
        let res = await httpClient.post(
            `/applicants/import/${importData.applicantId}`,
            importData.applicantData
        );
        return res.data;
    },
    async updateAssignedTo(order_id, user_id) {
        let res = await httpClient.put(`/orders/${order_id}`, {
            assignedTo: user_id,
        });
        return res.data.data;
    },
    async deleteMultiple(order_ids) {
        let res = await httpClient.post('/orders/multiple/delete', {
            order_ids,
        });
        return res.data;
    },
    async validateInvitedUser(queryString) {
        let { data } = await httpClient.get(`/invited/user${queryString}`);
        return data;
    },
    async registerUser(params) {
        let { data } = await httpClient.post('/user/register', params);
        return data;
    },
    async updateSearchCrimes(crime_id, params) {
        let { data } = await httpClient.put(
            `/search/crimes/${crime_id}`,
            params
        );
        return data;
    },
    async updateSearchEvictions(eviction_id, params) {
        let { data } = await httpClient.put(
            `/search/evictions/${eviction_id}`,
            params
        );
        return data;
    },
};
